import type { AlertDto, AlertValues, Currency, Minor } from "@nabla/api";
import { formatDate } from "../../design/format/dates.ts";
import { amount, budget } from "../../design/format/money.ts";
import { formatNumber } from "../../design/format/numbers.ts";
import type { Words } from "../../words/session.ts";
import { trackingHealthCopy as t } from "./copy.ts";

interface On {
  readonly alert: AlertDto;
  readonly words: Words;
  readonly currency: Currency | undefined;
}

export const alerts = {
  "medicao-quebrada": {
    says: (v: AlertValues<"medicao-quebrada">, on: On) =>
      t.medicao[v.tipo](formatDate(v.dia, on.words.today), formatNumber(v.compras), formatNumber(v.visitas), formatNumber(v.esperadas)),
    next: t.medicaoProximo,
  },
  "evento-sem-resultado": {
    says: (v: AlertValues<"evento-sem-resultado">, on: On) => {
      const gasto = on.currency === undefined ? "—" : amount({ minor: v.gasto, currency: on.currency });
      const evento = t.eventos[v.evento];
      return v.conjuntos === 1
        ? t.evento.um(on.alert.object?.name ?? "—", evento, gasto, v.dias)
        : t.evento.varios(v.conjuntos, evento, gasto, v.dias);
    },
    next: t.eventoProximo,
  },
  "anuncios-sem-utm": {
    says: (v: AlertValues<"anuncios-sem-utm">) => t.semUtm(v.campanha, v.anuncios),
    next: t.semUtmProximo,
  },
  "pagina-do-produto": {
    says: (v: AlertValues<"pagina-do-produto">) => `${pageSays(v)}${t.levam(v.anuncios, v.nomes)}`,
    next: (v: AlertValues<"pagina-do-produto">) => (v.problema === "preco-mudou" ? t.precoProximo : t.paginaProximo),
  },
};

function pageSays(v: AlertValues<"pagina-do-produto">): string {
  const price = (minor: Minor | undefined) => (minor === undefined ? "—" : budget({ minor, currency: v.moeda }));
  if (v.problema === "fora-do-ar") return t.pagina["fora-do-ar"](v.produto, v.status);
  if (v.problema === "preco-mudou") return t.pagina["preco-mudou"](v.produto, price(v.antes), price(v.agora));
  return t.pagina[v.problema](v.produto);
}
